import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
/** Reutiliza el mismo recurso que contexto 2 hasta disponer de un vídeo específico del testigo. */
import avatarFase2Ct3Mp4 from "../../assets/videos/avatar-fase2-ct3.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "./Scenario3.css";

const WITNESS_STATEMENT =
	"Estaba sentado en la terraza de enfrente tomando algo cuando escuché a una mujer gritar.\n\n" +
	"Miré hacia la plaza y vi a esa mujer señalando a un hombre y acusándolo de haberle quitado la cartera.\n\n" +
	"Vi que estaban discutiendo bastante acalorados, pero no vi ninguna pelea ni ningún forcejeo. Tampoco vi a nadie coger ninguna cartera.\n\n" +
	"Lo único que puedo decir es que ambos estaban bastante cerca antes de que empezara la discusión.\n\n" +
	"Sí recuerdo que él se puso bastante nervioso cuando ella empezó a acusarle.\n\n" +
	"También recuerdo que, en un momento determinado, se alejó unos metros de la zona durante unos segundos y después volvió.\n\n" +
	"Creo que dijo algo de encender un cigarrillo, pero no llegué a escuchar bien la conversación.";

const TYPEWRITER_MS_PER_CHAR = 70;

export default function Scenario3Context3() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const [visibleLen, setVisibleLen] = useState(0);
	const typingComplete = visibleLen >= WITNESS_STATEMENT.length;

	useEffect(() => {
		const id = window.setInterval(() => {
			setVisibleLen((n) => {
				const next = n + 1;
				if (next >= WITNESS_STATEMENT.length) {
					window.clearInterval(id);
					return WITNESS_STATEMENT.length;
				}
				return next;
			});
		}, TYPEWRITER_MS_PER_CHAR);
		return () => window.clearInterval(id);
	}, []);

	const displayed = WITNESS_STATEMENT.slice(0, visibleLen);

	return (
		<div className="start-game-page start-game-page--welcome sc3-context1-dialogue-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Escenario 3 · Evolución
						</span>
						<div className="start-game-avatar-wrap sc3-context1-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="metadata"
									aria-label="Testimonio en vídeo"
								>
									<source src={avatarFase2Ct3Mp4} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel sc3-context1-dialogue-panel">
						<p className="start-game-kicker sc3-context1-kicker">Testimonio</p>
						<p className="start-game-lead sc3-context1-typewriter" aria-live="polite">
							{displayed}
							{typingComplete ? null : (
								<span className="sc3-context1-caret" aria-hidden>
									▍
								</span>
							)}
						</p>
						<div className="start-game-footer sc3-context1-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO3_QUIZ3}
								activeScenario={activeScenario}
								label="Continuar"
								canContinue={typingComplete}
								lockedTitle="Espera a que termine el testimonio para continuar"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}
